<template>
    <div class="variations row">
        <div
            class="col-6"
        >
            <div
                class="row"
            >
                <template
                    v-for="variation in variations"
                >
                    <div class="col-6" :key="variation">
                        <label>{{
                                variation.detail == null ? "" : variation.detail[0].name
                            }}</label>
                        <fieldset class="form-group mb-3 d-flex">
                            <select class="single-select w-100 mb-3 categories-select ms-offscreen"
                                    v-model="variationData['variation_' + variation.attribute_id]"
                                    multiple
                                    @change="setVariations('variation_' + variation.attribute_id)"
                            >
                                <option value="" selected disabled>
                                    Select
                                    {{
                                        variation.detail == null ? "" : variation.detail[0].name
                                    }}
                                </option>
                                <option
                                    v-for="variationDetail in variation.variations"
                                    v-bind:value="variationDetail.id"
                                >
                                    {{
                                        variationDetail.detail == null
                                            ? ""
                                            : variationDetail.detail[0].name
                                    }}
                                </option>
                            </select>
                        </fieldset>
                    </div>
                </template>
            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div class="col-6">
                    <label>EAN</label>
                    <fieldset class="form-group">
                        <input
                            type="text"
                            id="item_height"
                            class="form-control round bg-transparent text-dark"
                            placeholder="Ввести EAN"
                            v-model="ean"
                        />
                    </fieldset>
                    <small
                        class="form-text text-danger"
                        v-if="errors.has('item_height')"
                        v-text="errors.get('item_height')"
                    ></small>
                </div>
                <div class="col-6">
                    <label>Цена</label>
                    <fieldset class="form-group mb-3">
                        <input
                            type="text"
                            id="item_width"
                            class="form-control round bg-transparent text-dark"
                            placeholder="Ввести цену"
                            v-model="price"
                        />
                    </fieldset>
                    <small
                        class="form-text text-danger"
                        v-if="errors.has('item_width')"
                        v-text="errors.get('item_width')"
                    ></small>
                </div>
                <div class="col-6">
                    <label>Остаток</label>
                    <fieldset class="form-group mb-3">
                        <input
                            type="number"
                            id="item_length"
                            class="form-control round bg-transparent text-dark"
                            placeholder="Ввести количество"
                            v-model="count"
                        />
                    </fieldset>
                    <small
                        class="form-text text-danger"
                        v-if="errors.has('item_length')"
                        v-text="errors.get('item_length')"
                    ></small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Variations",
    props: {
        attribute: {
            type: Number,
            required: true
        },
        errors: [],
    },
    data() {
        return {
            variations: [],
            variationData: [],
            ean: '',
            price: '',
            count: '',
        }
    },
    created() {
        this.$parent.$parent.loading = true;
        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        // if (this.selectedAttribute.indexOf(this.attribute) < 0) {
        //     this.selectedAttribute.push(this.attribute);
        //     this.setAttributes(this.attribute);
        // } else {
        //     this.$parent.$parent.loading = false;
        //     return false;
        // }
        // var name = "variation_" + this.attribute;
        // this.$set(this.variationData, name, []);

        axios
            .get(
                "/api/admin/attribute/" +
                this.attribute +
                "?getVariation=1&getDetail=1",
                config
            )
            .then(({data}) => {
                if (data.status == "Success") {
                    console.log(data.data)
                    this.variations.push(data.data);
                    this.variations.push(data.data);
                    // this.variations = res.data.data;
                }
            })
            .finally(() => (this.$parent.$parent.loading = false));
    },
    methods: {
        setVariations() {

        }
    }
}
</script>

<style scoped>

</style>
